import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const en = {
  nav: {
    home: "Home", services: "Services", about: "About", portfolio: "Our Work",
    testimonials: "Reviews", contact: "Contact", estimate: "Free Estimate",
  },
  hero: {
    kicker: "Family-Owned · Miami, FL",
    line1: "Craftsmanship",
    line2: "You Can",
    line3: "Trust.",
    sub: "Reliable handyman and home remodeling services across South Florida — done right the first time, guaranteed.",
    cta: "Get a Free Estimate",
    call: "Call 786-774-6692",
  },
  trust: [
    { title: "Family-Owned", desc: "A local family business that treats your home like our own." },
    { title: "Free In-Home Estimate", desc: "Clear, honest pricing before any work begins." },
    { title: "Full Warranty", desc: "Every repair and remodel backed by our guarantee." },
  ],
  servicesPreview: {
    kicker: "What We Do",
    title: "One call for every corner of your home",
    sub: "From quick repairs to full remodels — one trusted team for it all.",
    cta: "Explore All Services",
    items: [
      { title: "Handyman Repairs", desc: "Drywall, doors, fixtures, furniture assembly and everything in between." },
      { title: "Kitchen Remodeling", desc: "Cabinets, countertops, backsplashes and complete kitchen transformations." },
      { title: "Bathroom Remodeling", desc: "Showers, vanities, tile and full bathroom renovations." },
      { title: "Painting & Drywall", desc: "Interior and exterior painting with flawless finishes." },
      { title: "Flooring", desc: "Tile, laminate, vinyl and hardwood installation and repair." },
    ],
  },
  work: {
    kicker: "Our Work",
    title: "Recent projects around South Florida",
    sub: "Real homes. Real results. See what our family has built for yours.",
    cta: "View Full Portfolio",
  },
  testi: {
    kicker: "Testimonials",
    title: "What your neighbors say",
    cta: "Read All Reviews",
  },
  marquee: ["Miami", "Fort Lauderdale", "Doral", "Miami Beach", "Kendall", "Coconut Grove", "Aventura", "Pembroke Pines", "Coral Gables", "Hialeah"],
  cta: {
    kicker: "Ready When You Are",
    title: "Let's talk about your project",
    sub: "Free in-home estimates, honest pricing, and a family that stands behind every job.",
    btn: "Get a Free Estimate",
    call: "Or call 786-774-6692",
  },
  footer: {
    tagline: "Family-owned handyman and remodeling services. Craftsmanship you can trust, across South Florida.",
    explore: "Explore",
    contact: "Contact",
    area: "Service Area",
    areaText: "Miami, Fort Lauderdale, Doral, Miami Beach, Kendall, Coconut Grove, Aventura, Pembroke Pines and surrounding South Florida areas.",
    rights: "All rights reserved.",
  },
  servicesPage: {
    kicker: "Services",
    title: "Everything your home needs, under one roof",
    sub: "Handyman repairs and full remodeling — every job handled with the same care, whether it takes an hour or a month.",
    cta: "Get a Free Estimate",
    items: [
      { title: "Handyman Repairs", desc: "The to-do list ends here. Drywall patching, door and window repair, fixture replacement, caulking, furniture assembly, TV mounting, shelving and all the odd jobs that keep a home running." },
      { title: "Kitchen Remodeling", desc: "The heart of your home, rebuilt around your life. Custom cabinetry, countertops, backsplashes, lighting, plumbing fixtures and complete kitchen renovations from demo to final walkthrough." },
      { title: "Bathroom Remodeling", desc: "From tired to spa-grade. Walk-in showers, tub replacements, vanities, tile work, waterproofing and full bathroom renovations built to last in Florida's humidity." },
      { title: "Painting & Drywall", desc: "Crisp lines and flawless finishes, inside and out. Interior and exterior painting, drywall installation and repair, texture matching and stucco touch-ups." },
      { title: "Flooring", desc: "Floors that carry the whole room. Tile, luxury vinyl plank, laminate and hardwood installation, plus repairs, leveling and baseboard finishing." },
      { title: "Doors & Windows", desc: "Installed right, sealed tight. Door hanging and repair, locksets, sliding door tracks, window replacement, screens and weatherstripping." },
      { title: "Fixture Installation", desc: "The details that finish a room. Ceiling fans, lighting, faucets, sinks, toilets, garbage disposals and smart home devices — installed cleanly and correctly." },
    ],
  },
  aboutPage: {
    kicker: "About VIALFA",
    title: "A family business built on a handshake",
    p1: "VIALFA Construction & Development Group began the way the best companies do — around a family table, with a simple promise: do every job like it's for our own home.",
    p2: "Today, VIALFA Handyman Services brings that same standard to homes across South Florida. We're not a franchise or a call center. When you hire us, you get our family — our name, our reputation, and our personal responsibility on every single job.",
    p3: "Integrity, fairness and honesty aren't slogans on a wall. They're how we price, how we schedule, and how we clean up when we're done.",
    ownerCaption: "Carlos Vindel, Owner",
    chaptersTitle: "What we stand for",
    chapters: [
      { title: "Integrity", desc: "We tell you what your project actually needs — nothing more, nothing less. If a repair will do, we won't sell you a remodel." },
      { title: "Fairness", desc: "Flat-rate, honest pricing with free in-home estimates. We'll beat or match any comparable written quote." },
      { title: "Honesty", desc: "Clear timelines, real updates, and no surprises on the invoice. What we quote is what you pay." },
      { title: "Responsibility", desc: "Our name is on every job. We show up on time, protect your home, and guarantee our repairs — in writing." },
    ],
    guaranteesKicker: "Our Guarantees",
    guaranteesTitle: "Ten promises, one standard",
    guarantees: [
      "Beat or Match Price", "Family-Owned", "Locally-Owned",
      "Flat Rate Pricing", "Free Consultation", "Free In-Home Estimate", "Full Warranty",
      "Guaranteed Repairs", "On-Time Guarantee", "Protective Gear Used",
    ],
  },
  portfolioPage: {
    kicker: "Portfolio",
    title: "Work we're proud to sign",
    sub: "Filter by project type. Tap any project for a closer look.",
    all: "All",
    empty: "No projects in this category yet — check back soon.",
  },
  beforeAfter: {
    kicker: "Before & After",
    title: "Drag to see the transformation",
    sub: "Real projects, real results — slide the handle to compare.",
    before: "Before",
    after: "After",
  },
  testiPage: {
    kicker: "Testimonials",
    title: "Trusted by families across South Florida",
    sub: "Real reviews from real neighbors — the only advertising we've ever needed.",
  },
  contactPage: {
    kicker: "Contact",
    title: "Let's start the conversation",
    sub: "Call, write, or send us a message — a real person from our family team will answer.",
    phone: "Phone",
    email: "Email",
    instagram: "Instagram",
    area: "Service Area",
    formTitle: "Send us a message",
    name: "Name",
    emailField: "Email",
    phoneField: "Phone",
    message: "How can we help?",
    send: "Send Message",
    sending: "Sending…",
    successTitle: "Message received",
    successBody: "Thanks for reaching out — we'll get back to you shortly. For urgent needs, call 786-774-6692.",
    another: "Send another message",
  },
  estimate: {
    kicker: "Free Estimate",
    title: "Tell us about your project",
    sub: "Five quick steps. No obligation, no pressure — just an honest price from a family you can trust.",
    step: "Step",
    of: "of",
    next: "Continue",
    back: "Back",
    submit: "Submit Request",
    submitting: "Submitting…",
    s1: { title: "What kind of project is it?", options: ["Handyman Repair", "Remodeling", "Other"] },
    s2: {
      title: "Project details",
      rooms: "Rooms / areas involved",
      roomsPh: "e.g. Kitchen and guest bathroom",
      scope: "Describe the work",
      scopePh: "Tell us what you'd like done — the more detail, the more accurate your estimate.",
      timeline: "When would you like to start?",
      timelines: ["As soon as possible", "Within 2 weeks", "Within a month", "1–3 months", "Just planning"],
      budget: "Budget range",
      budgets: ["Under $500", "$500 – $1,500", "$1,500 – $5,000", "$5,000 – $15,000", "$15,000+", "Not sure yet"],
    },
    s3: {
      title: "Add photos (optional)",
      desc: "Photos help us give you a faster, more accurate estimate. Up to 6 images.",
      upload: "Tap to upload photos",
      hint: "JPG, PNG or WebP · max 10MB each",
    },
    s4: {
      title: "How do we reach you?",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      address: "Street address",
      zip: "ZIP code",
    },
    s5: { title: "Review your request", project: "Project", details: "Details", photos: "Photos", contact: "Contact", edit: "Edit", none: "None added" },
    done: {
      title: "Request received.",
      sub: "Thank you — a member of our family team will reach out within 24 hours. A confirmation email is on its way to you.",
      emergency: "Questions in the meantime? Call us at 786-774-6692.",
      home: "Back to Home",
    },
    required: "This field is required",
    error: "Something went wrong sending your request. Please call us at 786-774-6692.",
  },
  whatsapp: {
    msg: "Hi VIALFA, I'd like to ask about a project…",
    label: "Chat with us on WhatsApp",
  },
};

const es = {
  nav: {
    home: "Inicio", services: "Servicios", about: "Nosotros", portfolio: "Proyectos",
    testimonials: "Reseñas", contact: "Contacto", estimate: "Estimado Gratis",
  },
  hero: {
    kicker: "Empresa Familiar · Miami, FL",
    line1: "Artesanía en la",
    line2: "que Puedes",
    line3: "Confiar.",
    sub: "Servicios confiables de handyman y remodelación en el Sur de la Florida — bien hechos a la primera, garantizados.",
    cta: "Obtén un Estimado Gratis",
    call: "Llama al 786-774-6692",
  },
  trust: [
    { title: "Empresa Familiar", desc: "Un negocio local que cuida tu hogar como si fuera el nuestro." },
    { title: "Estimado Gratis a Domicilio", desc: "Precios claros y honestos antes de comenzar cualquier trabajo." },
    { title: "Garantía Total", desc: "Cada reparación y remodelación respaldada por nuestra garantía." },
  ],
  servicesPreview: {
    kicker: "Lo Que Hacemos",
    title: "Una sola llamada para cada rincón de tu hogar",
    sub: "Desde reparaciones rápidas hasta remodelaciones completas — un equipo de confianza para todo.",
    cta: "Ver Todos los Servicios",
    items: [
      { title: "Reparaciones Handyman", desc: "Drywall, puertas, accesorios, ensamblaje de muebles y todo lo demás." },
      { title: "Remodelación de Cocinas", desc: "Gabinetes, encimeras, salpicaderos y transformaciones completas de cocina." },
      { title: "Remodelación de Baños", desc: "Duchas, vanidades, azulejos y renovaciones completas de baño." },
      { title: "Pintura y Drywall", desc: "Pintura interior y exterior con acabados impecables." },
      { title: "Pisos", desc: "Instalación y reparación de azulejo, laminado, vinilo y madera." },
    ],
  },
  work: {
    kicker: "Nuestro Trabajo",
    title: "Proyectos recientes en el Sur de la Florida",
    sub: "Hogares reales. Resultados reales. Mira lo que nuestra familia ha construido para la tuya.",
    cta: "Ver Portafolio Completo",
  },
  testi: {
    kicker: "Testimonios",
    title: "Lo que dicen tus vecinos",
    cta: "Leer Todas las Reseñas",
  },
  marquee: ["Miami", "Fort Lauderdale", "Doral", "Miami Beach", "Kendall", "Coconut Grove", "Aventura", "Pembroke Pines", "Coral Gables", "Hialeah"],
  cta: {
    kicker: "Listos Cuando Tú Lo Estés",
    title: "Hablemos de tu proyecto",
    sub: "Estimados gratis a domicilio, precios honestos y una familia que respalda cada trabajo.",
    btn: "Obtén un Estimado Gratis",
    call: "O llama al 786-774-6692",
  },
  footer: {
    tagline: "Servicios familiares de handyman y remodelación. Artesanía en la que puedes confiar, en todo el Sur de la Florida.",
    explore: "Explorar",
    contact: "Contacto",
    area: "Área de Servicio",
    areaText: "Miami, Fort Lauderdale, Doral, Miami Beach, Kendall, Coconut Grove, Aventura, Pembroke Pines y áreas cercanas del Sur de la Florida.",
    rights: "Todos los derechos reservados.",
  },
  servicesPage: {
    kicker: "Servicios",
    title: "Todo lo que tu hogar necesita, bajo un mismo techo",
    sub: "Reparaciones y remodelaciones completas — cada trabajo con el mismo cuidado, tome una hora o un mes.",
    cta: "Obtén un Estimado Gratis",
    items: [
      { title: "Reparaciones Handyman", desc: "Aquí termina tu lista de pendientes. Reparación de drywall, puertas y ventanas, reemplazo de accesorios, sellado, ensamblaje de muebles, montaje de TV, repisas y todos esos trabajos que mantienen un hogar en marcha." },
      { title: "Remodelación de Cocinas", desc: "El corazón de tu hogar, reconstruido alrededor de tu vida. Gabinetes a medida, encimeras, salpicaderos, iluminación, accesorios de plomería y renovaciones completas desde la demolición hasta la entrega final." },
      { title: "Remodelación de Baños", desc: "De cansado a nivel spa. Duchas a ras de suelo, reemplazo de tinas, vanidades, azulejos, impermeabilización y renovaciones completas hechas para durar en la humedad de la Florida." },
      { title: "Pintura y Drywall", desc: "Líneas nítidas y acabados impecables, por dentro y por fuera. Pintura interior y exterior, instalación y reparación de drywall, texturas y retoques de estuco." },
      { title: "Pisos", desc: "Pisos que sostienen toda la habitación. Instalación de azulejo, vinilo de lujo, laminado y madera, además de reparaciones, nivelación y acabado de zócalos." },
      { title: "Puertas y Ventanas", desc: "Instaladas bien, selladas mejor. Colocación y reparación de puertas, cerraduras, rieles de puertas corredizas, reemplazo de ventanas, mallas y burletes." },
      { title: "Instalación de Accesorios", desc: "Los detalles que completan un espacio. Ventiladores de techo, iluminación, grifería, lavabos, inodoros, trituradores y dispositivos inteligentes — instalados limpia y correctamente." },
    ],
  },
  aboutPage: {
    kicker: "Sobre VIALFA",
    title: "Un negocio familiar construido con un apretón de manos",
    p1: "VIALFA Construction & Development Group nació como nacen las mejores empresas — alrededor de una mesa familiar, con una promesa simple: hacer cada trabajo como si fuera para nuestro propio hogar.",
    p2: "Hoy, VIALFA Handyman Services lleva ese mismo estándar a los hogares del Sur de la Florida. No somos una franquicia ni un call center. Cuando nos contratas, trabajas con nuestra familia — nuestro nombre, nuestra reputación y nuestra responsabilidad personal en cada trabajo.",
    p3: "Integridad, justicia y honestidad no son lemas en una pared. Son cómo cotizamos, cómo programamos y cómo dejamos todo limpio al terminar.",
    ownerCaption: "Carlos Vindel, Propietario",
    chaptersTitle: "En lo que creemos",
    chapters: [
      { title: "Integridad", desc: "Te decimos lo que tu proyecto realmente necesita — nada más, nada menos. Si una reparación basta, no te vendemos una remodelación." },
      { title: "Justicia", desc: "Precios fijos y honestos con estimados gratis a domicilio. Igualamos o mejoramos cualquier cotización comparable por escrito." },
      { title: "Honestidad", desc: "Tiempos claros, actualizaciones reales y sin sorpresas en la factura. Lo que cotizamos es lo que pagas." },
      { title: "Responsabilidad", desc: "Nuestro nombre está en cada trabajo. Llegamos a tiempo, protegemos tu hogar y garantizamos nuestras reparaciones — por escrito." },
    ],
    guaranteesKicker: "Nuestras Garantías",
    guaranteesTitle: "Diez promesas, un solo estándar",
    guarantees: [
      "Igualamos o Mejoramos Precio", "Empresa Familiar", "Negocio Local",
      "Precios Fijos", "Consulta Gratis", "Estimado Gratis a Domicilio", "Garantía Total",
      "Reparaciones Garantizadas", "Garantía de Puntualidad", "Uso de Equipo de Protección",
    ],
  },
  portfolioPage: {
    kicker: "Portafolio",
    title: "Trabajo que firmamos con orgullo",
    sub: "Filtra por tipo de proyecto. Toca cualquier proyecto para verlo de cerca.",
    all: "Todos",
    empty: "Aún no hay proyectos en esta categoría — vuelve pronto.",
  },
  beforeAfter: {
    kicker: "Antes y Después",
    title: "Arrastra para ver la transformación",
    sub: "Proyectos reales, resultados reales — desliza el control para comparar.",
    before: "Antes",
    after: "Después",
  },
  testiPage: {
    kicker: "Testimonios",
    title: "Con la confianza de familias en todo el Sur de la Florida",
    sub: "Reseñas reales de vecinos reales — la única publicidad que hemos necesitado.",
  },
  contactPage: {
    kicker: "Contacto",
    title: "Empecemos la conversación",
    sub: "Llama, escribe o envíanos un mensaje — una persona real de nuestro equipo familiar responderá.",
    phone: "Teléfono",
    email: "Correo",
    instagram: "Instagram",
    area: "Área de Servicio",
    formTitle: "Envíanos un mensaje",
    name: "Nombre",
    emailField: "Correo electrónico",
    phoneField: "Teléfono",
    message: "¿Cómo podemos ayudarte?",
    send: "Enviar Mensaje",
    sending: "Enviando…",
    successTitle: "Mensaje recibido",
    successBody: "Gracias por escribirnos — te responderemos pronto. Para urgencias, llama al 786-774-6692.",
    another: "Enviar otro mensaje",
  },
  estimate: {
    kicker: "Estimado Gratis",
    title: "Cuéntanos sobre tu proyecto",
    sub: "Cinco pasos rápidos. Sin compromiso ni presión — solo un precio honesto de una familia de confianza.",
    step: "Paso",
    of: "de",
    next: "Continuar",
    back: "Atrás",
    submit: "Enviar Solicitud",
    submitting: "Enviando…",
    s1: { title: "¿Qué tipo de proyecto es?", options: ["Reparación Handyman", "Remodelación", "Otro"] },
    s2: {
      title: "Detalles del proyecto",
      rooms: "Habitaciones / áreas involucradas",
      roomsPh: "ej. Cocina y baño de visitas",
      scope: "Describe el trabajo",
      scopePh: "Cuéntanos qué te gustaría hacer — mientras más detalle, más preciso será tu estimado.",
      timeline: "¿Cuándo te gustaría comenzar?",
      timelines: ["Lo antes posible", "Dentro de 2 semanas", "Dentro de un mes", "1–3 meses", "Solo estoy planificando"],
      budget: "Rango de presupuesto",
      budgets: ["Menos de $500", "$500 – $1,500", "$1,500 – $5,000", "$5,000 – $15,000", "Más de $15,000", "Aún no lo sé"],
    },
    s3: {
      title: "Agrega fotos (opcional)",
      desc: "Las fotos nos ayudan a darte un estimado más rápido y preciso. Hasta 6 imágenes.",
      upload: "Toca para subir fotos",
      hint: "JPG, PNG o WebP · máx. 10MB cada una",
    },
    s4: {
      title: "¿Cómo te contactamos?",
      name: "Nombre completo",
      email: "Correo electrónico",
      phone: "Teléfono",
      address: "Dirección",
      zip: "Código postal",
    },
    s5: { title: "Revisa tu solicitud", project: "Proyecto", details: "Detalles", photos: "Fotos", contact: "Contacto", edit: "Editar", none: "Ninguna agregada" },
    done: {
      title: "Solicitud recibida.",
      sub: "Gracias — un miembro de nuestro equipo familiar te contactará dentro de 24 horas. Un correo de confirmación va en camino.",
      emergency: "¿Preguntas mientras tanto? Llámanos al 786-774-6692.",
      home: "Volver al Inicio",
    },
    required: "Este campo es obligatorio",
    error: "Hubo un problema al enviar tu solicitud. Por favor llámanos al 786-774-6692.",
  },
  whatsapp: {
    msg: "Hola VIALFA, quisiera preguntar sobre un proyecto…",
    label: "Escríbenos por WhatsApp",
  },
};

i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, es: { translation: es } },
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  returnObjects: true,
});

export default i18n;
